import { Navigate, useParams } from "react-router-dom";
import useRegionPath from "src/hooks/useRegionPath";

export default function CompanyToInvoiceRedirect() {
    const { u_company_id, sys_id } = useParams();
    const region = useRegionPath(); 

    return <Navigate replace to={`/${region}/companies/${u_company_id}/${sys_id}/invoices`} />;
}